import "./navbar.scss";
import decodeToken from "../../utils/decodeToken";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useState } from "react";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import { useNavigate } from "react-router-dom";

const Navbar = ({ setIsSidebar, isSidebar }) => {
  const user = decodeToken() || {};
  const full_name = user.full_name || user.name || "User";
  const initial = (full_name || "?").trim().charAt(0).toUpperCase();

  const navigate = useNavigate();

  const onLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogoutClick = () => {
    handleClose();
    onLogout();
  };

  const onToggleSidebar = () => {
    setIsSidebar(!isSidebar);
  };

  const sidebarOpen = Boolean(isSidebar);

  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="navbarLead">
          <IconButton
            onClick={onToggleSidebar}
            className="navbar-mobile-toggle adminRoundToggle"
            aria-label={sidebarOpen ? "Close menu" : "Open menu"}
            size="small"
            sx={{ display: { xs: "inline-flex", md: "none" } }}
          >
            {sidebarOpen ? (
              <ChevronLeftRoundedIcon />
            ) : (
              <ChevronRightRoundedIcon />
            )}
          </IconButton>
          {/* <span className="logo-m">
            <img
              className="navbarBrandLogo"
              src="/shaagird-logo.svg"
              alt="Shaagird"
            />
          </span> */}
        </div>
        <div className="items ml-auto">
          <div className="item">
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              className="navbar-user-trigger"
              startIcon={
                <Avatar
                  alt=""
                  src={user.avatar_url || user.profile_image || undefined}
                  sx={{
                    width: 36,
                    height: 36,
                    fontSize: 15,
                    fontWeight: 700,
                    bgcolor: "#261134",
                    color: "#ffcc00",
                    border: "2px solid rgba(255, 204, 0, 0.35)",
                  }}
                >
                  {initial}
                </Avatar>
              }
              endIcon={<ExpandMoreOutlinedIcon />}
            >
              {full_name}
            </Button>
          </div>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleLogoutClick}>
              <ListItemIcon>
                <LogoutRoundedIcon fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
